var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToggleLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 16,
    viewBox: "0 0 31 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toggle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    width: 25,
    height: 12,
    transform: "translate(6 2)",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 2",
    cx: 7.93333,
    cy: 8,
    rx: 7.93333,
    ry: 8,
    fill: "#2E89E2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleLeft);
export default __webpack_public_path__ + "static/media/toggle-left.353c364b6c6d89d69dff5a56b5be818a.svg";
export { ForwardRef as ReactComponent };